// eslint-disable-next-line import/no-anonymous-default-export
export default {
    CADASTRO: 0,
    ALTERACAO: 1
}